module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABSElEQVR42pWSPUvDUBSGs/kn/Acu0sEIWiqK+IWgFnEXtw5OotAhg0oUREdFxVkEFxdBnMRJVKiJYFPwszRJoRpRTG5t8pp7htBakuiBh/fwJveBSyIAICRJwh/I+ggcAESDgDEG27abcBynXjIbKuBTPutvgo+8SM+5wPWZDhV83i/DZTqH9rfrIepXlhquYocKvO8Kj2D/yI/i15AkXFAjQbDbz2P1xAtq1pp/0IRRUjCfacHcjICikqTckgV4nhctcK1J4vy4FUahh3IhI9CuaymoqhotwNdUFPFXqJppVMtpMGMCdnGckjqTuniBftoHKzeMd2WEsnIxgNJJL/0Pr1eD8YKnwyQe9rug7Ygo7HXi8aCbupejFGWsICe343Yjgfy2CG1XxN1mB25WqYO6nogXXGbboogWMMboO0dA74QK/kEg+AF8CQd/ykAeRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/image-x-generic.png
// module id = A4+a
// module chunks = 1